






































import { Component, Vue, Prop} from "vue-property-decorator";
import { Getter ,Action} from "vuex-class";
import desensitizeName from '@/common/utils/desensitizeName';
@Component({
  components: {
   
  }
})
export default class DistributeParticipantModal extends Vue {
  @Prop() participantModalShow!: boolean; 
  @Getter("distributePurchaseList") distributePurchaseList! : object;
  desensitizeName:Function = desensitizeName;
  handleClose(){
    this.$emit('hide')
  }
}
